/**
 * IDN Setter Sketch
 * Main entry point for the p5.js interaction canvas.
 */

window.figure = undefined;
window.ball = undefined;
window.leftbbcoord = undefined;
window.rightbbcoord = undefined;
window.gravity = undefined;
window.lastHit = 0;
window.textElements = []; // Array to store {x, y, event} objects
window.canvasEventsActive = false;
window.groundY = undefined;
window.ballStartPos = undefined;
window.HITTINGHEIGHTTRESHOLD = undefined; // Dynamically computed as canvas height / 5
window.holeSize = 10;

// ===================================================================
//  P5.JS CORE FUNCTIONS
// ===================================================================

function setup() {
  const container = document.getElementById('canvas-container');
  let canvas = createCanvas(container.offsetWidth, container.offsetHeight);
  canvas.parent('canvas-container');
  rectMode(CENTER);

  // Set Ground Position
  groundY = height - 30;

  // Hitting threshold = 2/5 of canvas height (the high-kick detection zone)
  HITTINGHEIGHTTRESHOLD = calculateHittingHeightThreshold(height);
  // Initialize Interaction
  interaction = new InteractionHandler();
  
  // Initialize Physics
  gravity = createVector(0, 0.4);
    
  // Initialize Figure with modular scale
  const scale = 0.7;
  // Calculate pos so feet are on groundY
  // hipY = groundY - (thigh + shin + footOffset)
  // pos.y = hipY - hipOffset.y
  const posHoldY = groundY - (200 * scale);
  const figureStartPos = createVector(width / 2, posHoldY);
  figure = new Figure(figureStartPos, scale);

  // Initialize Ball relative to groundY
  ballStartPos = createVector(width / 2 - (30 * scale), HITTINGHEIGHTTRESHOLD + 5);
  ball = new Ball(ballStartPos, 25 * scale, 0.3);

  // Initial calculation of bounding box
  leftbbcoord = ballStartPos.x - BALLBBOXWIDTH / 2;
  rightbbcoord = ballStartPos.x + BALLBBOXWIDTH / 2;

  // Initialize Text Positions (Circle distribution)
  _initializeTextPositions(figureStartPos);
}

function draw() {
  clear();

  // Update text animation state in narrative engine
  lastHit += 1;
  if (typeof window.setTextAnimationState === 'function') {
    window.setTextAnimationState(lastHit < INACTIVITYGAP);
  }

  // Handle Canvas Events state
  if (canvasEventsActive) {
    // stroke(255,0,0);
    // strokeWeight(30);
    // rect(0, 0, width, height);
    leftbbcoord = 0;
    rightbbcoord = width;
    _drawCanvasEvents();
  } else {
    leftbbcoord = ballStartPos.x - BALLBBOXWIDTH / 2;
    rightbbcoord = ballStartPos.x + BALLBBOXWIDTH / 2;
    figure.update();
    ball.update(gravity, figure, textElements, canvasEventsActive);
  }
  
  // 2. Draw
  if (!canvasEventsActive) {
    figure.draw();
    ball.draw();
  }

    // Draw optional debug points for boundaries
  // fill(255,0,0); circle(width/2, HITTINGHEIGHTTRESHOLD, 10); point(rightbbcoord, 20);

}

// ===================================================================
//  EVENT HANDLERS
// ===================================================================

function mousePressed() {
  if (canvasEventsActive) {
    for (let item of textElements) {
      if (item.event) {
        // Check if clicked within the dynamic hitbox (top-left logic)
        if (mouseX >= item.x && mouseX <= item.x + item.w &&
            mouseY >= item.y && mouseY <= item.y + item.h) {
          
          item.hitTime = millis();
          
          // Wait 1 second (synced with animation) before handling the event
          setTimeout(() => {
            if (typeof window.onCanvasEventHit === 'function') {
              window.onCanvasEventHit(item.event);
            }
          }, 1000);
          
          break;
        }
      }
    }
  } else {
    if (dist(mouseX, mouseY, figure.anklePos.x, figure.anklePos.y) < figure.config.leg.foot.width * 1.5) {
      interaction.isDraggingLeg = true;
    } else if (dist(mouseX, mouseY, ball.pos.x, ball.pos.y) < ball.radius) {
      interaction.isDraggingBall = true;
    }
  }
}

function mouseReleased() {
  interaction.isDraggingLeg = false;
  interaction.isDraggingBall = false;
}

function touchStarted() {
  mousePressed();
  if (mouseX >= 0 && mouseX <= width && mouseY >= 0 && mouseY <= height) {
    return false;
  }
}

function touchEnded() {
  mouseReleased();
}

function windowResized() {
  const container = document.getElementById('canvas-container');
  if (container) {
    resizeCanvas(container.offsetWidth, container.offsetHeight);
    groundY = height - 20;
    HITTINGHEIGHTTRESHOLD = calculateHittingHeightThreshold(height);
    // Update boundaries
    leftbbcoord = ballStartPos.x - BALLBBOXWIDTH / 2;
    rightbbcoord = ballStartPos.x + BALLBBOXWIDTH / 2;
    
    // Ensure figure and ball stay centered
    if (figure) figure.pos.x = width / 2;
    if (ball && !interaction.isDraggingBall) ball.pos.x = width / 2 - (20 * (figure ? figure.scale : 1));
  }
}

// ===================================================================
//  GLOBAL CANVAS EVENT HANDLERS (Called by narrative engine)
// ===================================================================

window.updateCanvasEvents = (events) => {
  textElements = [];
  const M = events.length;
  if (M === 0) return;

  const padding = 40; // Increased padding from edges
  const heightOfTape = height * 4 / 5;

  const areaHeight = heightOfTape - 2 * padding;
  const areaWidth = width - 2 * padding;
  fill(255, 0, 255);
  point(0, 0);
  rect(padding, padding, width - padding, heightOfTape - padding);

  const stepY = M > 1 ? areaHeight / (M - 1) : areaHeight / 2;

  push();
  textFont('Roboto');
  textSize(16);
  textAlign(LEFT, TOP);
  textWrap(WORD);

  for (let i = 0; i < M; i++) {
    const title = events[i].title;
    let w = textWidth(title) + 40; // Extra horizontal padding
    let h = 70; // Base height

    // Handle long text wrapping
    if (w > areaWidth) {
      w = areaWidth;
      const lines = Math.ceil(textWidth(title) / (w - 20));
      h = Math.max(70, lines * 22 + 30);
    }

    // New Algorithm: Vertical step distribution
    const y = padding + (i * stepY) - (h / 2); // Center h on the step point if possible
    const maxX = Math.max(padding, width - w - padding);
    const x = random(padding, maxX);
    
    // Constrain Y to be within the P area bounds
    const constrainedY = constrain(y, padding, heightOfTape - h - padding);
    
    textElements.push({ x, y: constrainedY, w, h, event: events[i], hitTime: 0 });
  }
  pop();
};

window.setCanvasEventsVisibility = (visible) => {
  canvasEventsActive = visible;
};

// ===================================================================
//  PRIVATE HELPERS
// ===================================================================

function _initializeTextPositions(origin) {
  // Clearing or re-initializing for random distribution
  textElements = [];
  const padding = 10;
  const heightOfTape = height * 4 / 5;
  const margin = 15;
  const maxWidth = width - 2 * padding;

  for (let i = 0; i < N_TEXTS; i++) {
    let x, y;
    const w = Math.min(120, maxWidth); 
    const h = 30;
    const maxX = Math.max(padding, width - w - padding);
    const maxY = Math.max(padding, heightOfTape - h - padding);

    for (let tries = 0; tries < 100; tries++) {
      x = random(padding, maxX);
      y = random(padding, maxY);
      if (!_checkOverlap(x, y, w, h, textElements, margin)) break;
    }
    textElements.push({ x, y, w, h, event: null, hitTime: 0 });
  }
}

function _checkOverlap(x, y, w, h, elements, margin) {
  for (let item of elements) {
    if (x < item.x + item.w + margin &&
        x + w + margin > item.x &&
        y < item.y + item.h + margin &&
        y + h + margin > item.y) {
      return true;
    }
  }
  return false;
}

function _drawCanvasEvents() {
  const heightOfTape = height * 4 / 5;

  push(); // Isolate all event-related drawing
  rectMode(CORNER);

  // Draw net
  noFill();
  stroke(0);
  strokeWeight(1);
  for (let i = 0; i < width; i += holeSize) {
    for (let j = heightOfTape; j < height; j += holeSize) {
      square(i, j, holeSize);
    }
  }
  // Draw top tape
  fill(0);
  rect(0, heightOfTape - holeSize, width, holeSize);

  // Draw text
  noStroke();
  textFont('Roboto');
  // textStyle(ITALIC); // User commented this out in snippet
  textSize(16);
  textAlign(LEFT, TOP);
  
  for (let item of textElements) {
    if (item.event) {
      push();
      if (item.hitTime > 0) {
        // 1s ease-out animation for font weight (synced with timeout)
        let t = (millis() - item.hitTime) / 1000;
        t = constrain(t, 0, 1);
        // Cubic ease-out
        let easedT = 1 - Math.pow(1 - t, 3);
        let weight = lerp(400, 900, easedT);
        textStyle(weight);
      } else {
        textStyle(400);
      }
      
      fill(0);
      noStroke();
      // Draw text within its textbox
      text(item.event.title, item.x, item.y, item.w, item.h);
      
      // Debug visual for the hitbox (from user request)
      // noFill();
      // stroke(0, 100);
      // strokeWeight(1);
      // rect(item.x, item.y, item.w, item.h);
      pop();
    }
  }
  pop();
}


/**
 * Calculates the hitting height threshold based on canvas height.
 * @param {number} canvasHeight - The current height of the canvas.
 * @returns {number} The calculated threshold value.
 */
function calculateHittingHeightThreshold(canvasHeight) {
  return canvasHeight / 5 * 2;
}


window.setup = setup; window.draw = draw; window.mousePressed = mousePressed; window.mouseReleased = mouseReleased; window.touchStarted = touchStarted; window.touchEnded = touchEnded; window.windowResized = windowResized;
